<template>
  <b-container>

    <b-row class="justify-content-md-center mb-3">
      <b-col cols="12" md="auto">
        <h3>Benutzer</h3>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col col lg="6">
        <b-form-group
            label="Suche"
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Begriff..."
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''" class="secondary">löschen</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col col lg="6" class="text-right">
        <b-button variant="link" to="/userEdit">
          <font-awesome-icon
              :icon="['fa-solid', 'fa-user-plus']"
              class="cursor-pointer mr-1 link-primary"
          />
        </b-button>
      </b-col>
    </b-row>

    <b-table
        sticky-header
        striped hover
        :fields="fields"
        :items="getUserList"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        stacked="md"
        show-empty
        small
        @filtered="onFiltered"
    >

      <template #cell(company)="data">

        <strong>{{ data.value.name }}</strong><br/>
        <span v-if="data.value.additional_address != ''">{{ data.value.additional_address }}<br/></span>
        {{ data.value.street }}<br/>
        {{ data.value.plz }} {{ data.value.city }}
        <span
            v-if="data.value.statistic_start_date_formatted"
            class="text-danger"
        ><br/>Daten ab: {{ data.value.statistic_start_date_formatted }}</span>

      </template>

      <template #cell(name)="data">

        <strong>{{ data.value.firstname }} {{ data.value.lastname }}</strong><br/>
        {{ data.value.telephone }}<br/>
        <a
            :href="'mailto:' + data.value.email"
            class="btn-link link-primary">{{ data.value.email }}</a>

      </template>

      <template #cell(status)="data">

        <span v-if="data.value == 1">
          <font-awesome-icon
              :icon="['fa-solid', 'check']"
              class="cursor-pointer"
          />
        </span>

        <span v-else>
          <font-awesome-icon
              :icon="['fa-solid', 'xmark']"
              class="cursor-pointer"
          />
        </span>

      </template>

      <template #cell(no_statistic)="data">

        <span v-if="data.item.company.no_statistic == 1">
          <font-awesome-icon
              :icon="['fa-solid', 'xmark']"
              class="cursor-pointer"
          />
        </span>

        <span v-else>
          <font-awesome-icon
              :icon="['fa-solid', 'check']"
              class="cursor-pointer"
          />
        </span>

      </template>

      <template #cell(last_login)="data">

        <span
            v-if="data.value !== '' && data.value != '00.00.0000'">{{ data.value }}</span>

        <span
          v-else>noch nie</span>

      </template>

      <template #cell(last_insert)="data">

        <span
            v-if="data.value !== '' && data.value != '00.00.0000'">
          <span
            v-if="data.item.last_insert_is_red == 1"
            class="text-danger">{{ data.value }}</span>

          <span
            v-else>{{ data.value }}</span>

        </span>

        <span
            v-else>noch nie</span>

      </template>

      <template #cell(edit)="data">

        <b-link
            :to="'/userEdit/' + data.item.user_id"
            v-if="checkUserEdit(data.item)"
        >
          <font-awesome-icon
                :icon="['fa-solid', 'user-pen']"
                class="cursor-pointer link-primary"
          />
        </b-link>

      </template>

    </b-table>

  </b-container>
</template>

<script>

/*
<pre>{{ getDates(new Date("2021-01-01T00:00:00"), new Date("2022-03-08T00:00:00")) }}</pre>
 */

import { mapMutations, mapGetters, mapActions } from 'vuex';
import axios from "axios";

export default {
  name: "areaUserList",
  data() {
    return {
      API_URL: process.env.VUE_APP_API,
      fields: [
        {
          key: 'company',
          label: 'Attraktion',
          sortable: true
        },
        {
          key: 'name',
          label: 'Name',
          sortable: false
        },
        {
          key: 'type',
          label: 'Typ',
          sortable: true
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true
        },
        {
          key: 'no_statistic',
          label: 'Statistik',
          sortable: true
        },
        {
          key: 'last_login',
          label: 'Letzter Login',
          sortable: true
        },
        {
          key: 'last_insert',
          label: 'Letzte Eintragung',
          sortable: true
        },
        {
          key: 'edit',
          label: 'Bearbeiten',
          sortable: true
        }
      ],
      filter: null,
      filterOn: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 5000,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
    }
  },
  mounted() {

    if (!this.$store.getters.getIsLoggedIn) {
      this.$router.push('/login');
    }

    this.loadUserList();
    // Set the initial number of items
    //this.totalRows = this.getUserList.length
  },
  computed: {
    ...mapGetters([
      'getUserList',
      'getUser'
    ]),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
    },
  },
  methods: {
    ...mapMutations([
    ]),
    ...mapActions([
    ]),
    ...mapGetters([
    ]),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getFormattedDate(date) {

      var res = date.toISOString().slice(0,10).split(/-/);
      return res[2] + '.' + res[1] + '.' + res[0];

    },
    getDates(startDate, endDate) {
      //first the function and variable definitions
      let dates = []
      const addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      //now our Sunday check
      let currentDate = startDate
      if (currentDate.getDay() > 0) {
        //console.log('not a sunday...adjusting')
        currentDate.setDate(currentDate.getDate() - ((currentDate.getDay() + 6) % 7));
      }

      while (currentDate <= endDate) {
        let endWeekDate = addDays.call(currentDate, 6);

        var week = (new Date(currentDate)).getWeek();
        var old_year = currentDate.getFullYear();
        var new_year = endWeekDate.getFullYear();

        var year = old_year;

        if (week == 1) {
          year = new_year;
        }

        var week_str = week;

        if (week <= 9) week_str = '0' + week;

        dates.push(
            {
              begin: currentDate,
              begin_formatted: this.getFormattedDate(currentDate),
              end: endWeekDate,
              end_formatted: this.getFormattedDate(endWeekDate),
              week: week,
              week_str: week_str,
              year: year
            });
        currentDate = addDays.call(currentDate, 7);
      }
      return dates;
    },

    async loadUserList() {

      //console.log('loadUserList');

      var cookie = this.$store.getters.getToken;

      const response = await axios.post(
          this.API_URL,
          {
            type: 'get_userlist',
            cookie: cookie,
          }
      );

      //console.log(response);

      if (response.data.error) {

        //console.log(response);
        this.$store.dispatch('setUserList', {});

      } else {

        //console.log('response');
        //console.log(response.data);
        this.$store.dispatch('setUserList', response.data);
        // Set the initial number of items
        this.totalRows = this.getUserList.length;
        //console.log(this.getUserList);

      }

    },
    checkUserEdit(actual_user) {
      //console.log(actual_user);
      //console.log(this.getUser.user_id);

      //wenn kein Admin
      if (actual_user.user_level < 40) return true;

      //admin
      let user = this.getUser;

      if (user.user_level == 40) return true;

      return false;

    }

}
}
</script>

<style scoped>

</style>